import { useCSSProperty } from './useCSSProperty';

export const useCSSPropertys = () => {
    const { setValue: setTableFullCellCqh } = useCSSProperty({
        key: '--table-revamp-full-cell-cqh',
        defaultValue: '1px',
    });
    const { setValue: setTableGridCellCqh } = useCSSProperty({
        key: '--table-revamp-grid-cell-cqh',
        defaultValue: '1px',
    });
    const { setValue: setTableMiniCellCqh } = useCSSProperty({
        key: '--table-revamp-mini-cell-cqh',
        defaultValue: '1px',
    });
    const { setValue: setMultibetGridCellHeaderCqh } = useCSSProperty({
        key: '--multibet-grid-cell-header-cqh',
        defaultValue: '0',
    });
    const { setValue: setMultibetGridCellBetAreaCqh } = useCSSProperty({
        key: '--multibet-grid-cell-bet-area-cqh',
        defaultValue: '0',
    });
    const { setValue: setMultibetHeightCqw } = useCSSProperty({
        key: '--multibet-video-height-cqw',
        defaultValue: '0',
    });
    const { setValue: setMultibetWidthCqh } = useCSSProperty({
        key: '--multibet-video-width-cqh',
        defaultValue: '0',
    });
    const { setValue: setBetViewCqh } = useCSSProperty({
        key: '--bet-view-cqh',
        defaultValue: '0',
    });
    const { setValue: setECardCqh } = useCSSProperty({
        key: '--e-card-cqh',
        defaultValue: '0',
    });

    const { setValue: setMultiBetVideoHeight } = useCSSProperty({
        key: '--multibet-video-height',
        defaultValue: '1px',
    });
    // const { setValue: setMultiBetVideoWidth } = useCSSProperty({
    //     key: '--multibet-video-width',
    //     defaultValue: '1px',
    // });
    const { setValue: setMultiBetVideoTop } = useCSSProperty({
        key: '--multibet-video-top',
        defaultValue: '-1000px',
    });
    const { setValue: setMultiBetVideoLeft } = useCSSProperty({
        key: '--multibet-video-left',
        defaultValue: '-1000px',
    });
    const { setValue: setMultiBetVideoPlace } = useCSSProperty({
        key: '--multi-bet-video',
        defaultValue: 'auto',
    });

    return {
        setTableFullCellCqh,
        setTableGridCellCqh,
        setTableMiniCellCqh,
        setMultibetGridCellHeaderCqh,
        setMultibetGridCellBetAreaCqh,
        setBetViewCqh,
        setECardCqh,
        setMultibetHeightCqw,
        setMultibetWidthCqh,
        setMultiBetVideoHeight,
        // setMultiBetVideoWidth,
        setMultiBetVideoTop,
        setMultiBetVideoLeft,
        setMultiBetVideoPlace,
    };
};

export type useCSSPropertyState = ReturnType<typeof useCSSPropertys>;
